import { h } from 'preact';
import Store from 'store/store';
import 'store/bolt/header';
import { accessNested, joinClasses } from 'utils/utils';
import { getRelativePageUrl } from 'utils/bolt/index';
import Link from 'components/bolt/link/link';
import 'store/bolt/header';
import * as BaseComp from 'components/bolt/header/header.js';
import s from 'components/bolt/header/header.sss';
import { isDualViewEnabled } from 'utils/bolt/index';
import Socials from 'components/bolt/socials/socials';
import { getDynamicData } from 'utils/bolt/dynamicData';

export default class Header extends BaseComp.default {
	
	constructor(props) {
		super(props);
		this.hasScrolled = false;
	}

	componentDidMount() {
		super.componentDidMount?.();
		if (this.props.appData?.options?.cmsManaged) {
			this.loadCustomData();
		}
	}

	async loadCustomData() {
		const dynamicData = await getDynamicData('landing');
		if (!dynamicData?.header) return;

		const socialsObj = (dynamicData.header.socials || []).reduce((acc, s) => {
			if (!s.platform) return acc;
			acc[s.platform.toLowerCase()] = {
				destination: s.link,
				title: s.title,
				order: 0
			};
			return acc;
		}, {});

		const cmsLogo = this.props.appData?.header?.powsterHeader?.logo || {};
		this.dynamicData = {
			logo: dynamicData.header.logo
				? {
					src: dynamicData.header.logo,
					alt: cmsLogo.alt || 'Logo',
					showOnMobile: cmsLogo.showOnMobile || false,
					path: cmsLogo.path || '',
				}
				: null,
			socials: socialsObj
		};

		this.forceUpdate();
	}



	renderPersistentButton() {
		const socials = (this.dynamicData?.socials && Object.keys(this.dynamicData.socials).length > 0)
			? this.dynamicData.socials
			: this.props.appData?.header?.powsterHeader?.follow || {};

		if (!Object.keys(socials).length) return null;

		return (
			<Socials
				class={joinClasses(s.socials, this.props.headerData.open && s.open)}
				socials={socials}
				navOpen={this.props.headerData.open}
				key="socials"
			/>
		);
	}

	renderHeaderLogo(logoData) {

		logoData = logoData || this.dynamicData?.logo || this.props?.appData?.header?.powsterHeader?.logo;
		if (!logoData) return;

		const store = Store.get();
		const activePercentage = accessNested(store, 'activePercentage', 1);
		this.hasScrolled = activePercentage <= .8;

		const isDesktopSize = this.props?.client?.isDesktopSize;
		const showOnMobile = this.props?.appData?.header?.powsterHeader?.logo?.showOnMobile || false;
		if (!logoData || (!isDesktopSize && !showOnMobile)) return;

		const { pageExclusions, pageInclusions, path, sameWindow, src, alt, width, height } = logoData;

		const headerLogoExclusions = (pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const headerLogoInclusions = (pageInclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const activePage = this.props.activePage;

		let hideHeaderLogo;
		if (headerLogoInclusions.length > 0) {
			hideHeaderLogo = !headerLogoInclusions.includes(activePage);
		} else {
			hideHeaderLogo = headerLogoExclusions.includes(activePage);
		}

		const className = joinClasses(s.headerLogo, hideHeaderLogo && s.hide, !path && s.unclickable, showOnMobile && s.showOnMobile, this.hasScrolled && s.hasScrolled);
		const content = <img src={src} alt={alt} width={width} height={height} />;

		let attributes = {
			key: 'headerLogo',
			class: className,
		};
		if (!path) {
			return <div {...attributes}>{content}</div>;
		}

		if (/^(https?:\/\/|mailto:)/i.test(path)) {
			attributes.href = path;
			attributes.target = sameWindow ? '_self' : '_blank';
			attributes.rel = 'noopener noreferrer';
			attributes.onClick = () => this.trackPersistentButtonClick(path, alt || 'headerLogo');
		} else {
			const [, pageId, queryString, hash] = path.match(/^(.*?)(\?.*?)?(#.*)?$/) || [];
			attributes.href = getRelativePageUrl(pageId || path, queryString, hash) || '#';
			attributes.onClick = e => {
				e.preventDefault();
				this.triggerPersistentButton(path, content);
			};
		}

		return <Link {...attributes}>{content}</Link>;
	}
}
